import { Component, OnInit } from '@angular/core';
import {ModalExtended} from 'ngx-dynamic-modal';
import {VnaCampaignService} from '../../../vna-campaign/services/vna-campaign.service';
import {Observable} from 'rxjs/Observable';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AlertaService} from '../../../../../shared/services/alerta.service';
import {Router} from '@angular/router';
import {VnaPortalAppSelected} from '../../../../../core/data/messaging/VnaPortalAppSelected';
import {MessagingService} from '../../../../../core/service/messaging.service';

@Component({
  selector: 'app-export-external-callback',
  templateUrl: './export-external-callback.component.html',
  styleUrls: ['./export-external-callback.component.scss']
})
export class ExportExternalCallbackComponent extends ModalExtended implements OnInit {

    data: Object;
    loading: boolean = false;
    form: FormGroup;

    constructor(private campaignService: VnaCampaignService, private fb: FormBuilder, private alertService: AlertaService, private router: Router, private messaging: MessagingService){
        super();

        this.form = this.fb.group({
            'campaign' : new FormControl('', Validators.required)
        })
    }

    onExit(): void {
        this.applyCallback(1);
        this.close();
    }

    requestAutocompleteCampaigns = (text: string): Observable<any> => {
        return this.campaignService.findByMatchName(text).map(
            (rows: Array<Object>) => {
                return rows.map( (o) => {
                    return {
                        'value': o['pk'],
                        'display' : o['name']
                    }
                })
            }
        );
    };

    export(): void {
        this.loading = true;

        const pkCamp = this.form.value.campaign[0]['value'];
        this
            .campaignService
            .exportExternalCallback(this.data['pk'], pkCamp)
            .subscribe(
                (result) => {
                    this.loading = false;
                    this.alertService.addAlert('confirm','External callback exported succesfully. Do you want to be redirected to target campaign config?')
                        .then((r)=>{
                            if(r.value) {
                                this.messaging.sendMessage(new VnaPortalAppSelected(result.iso_portal));
                                this.router.navigateByUrl('/phone/config/campaign/' + pkCamp);
                                this.onExit();
                            }
                        })
                }
            )
    }

    ngOnInit() {

    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/form/components/export-external-callback/export-external-callback.component.ts